import { Outlet } from "react-router-dom"



export default function JobsDahOut() {
  return (
    <div className="blogDashboard" style={{width:"100%"}}>
   <h1>Dashboard Jobs Out</h1>
    <Outlet/>
        
    </div>
  )
}
